module.exports = __webpack_public_path__ + "static/media/wall_entrance.00dbd9c0.png";